import {
    GET_ORDERS_LIST_DATA,
    GET_ORDERS_LIST_DATA_SUCCESS,
    GET_ORDERS_LIST_DATA_FAILURE,
    GET_ALL_ORDERS_LIST_DATA,
    GET_ALL_ORDERS_LIST_DATA_SUCCESS,
    GET_ALL_ORDERS_LIST_DATA_FAILURE,
    GET_REFINED_ORDERS_LIST_DATA,
    GET_REFINED_ORDERS_LIST_DATA_SUCCESS,
    GET_REFINED_ORDERS_LIST_DATA_FAILURE,
    SHOW_ORDER_FILTER,
    CLOSE_ORDER_FILTER,
    TOGGLE_ORDER_FILTERS,
    RESET_ORDER_LIST,
    ORDERS_LIST_FILTERS_UPDATE,
    ORDERS_LIST_DATA_UPDATE,
    FILTER_AND_ORDERLIST_UPDATE,
    SET_ORDERS_DATE_FILTER,
    SET_DYNAMIC_Z_INDEX,
    SET_ORDERS_LOADING,
    AWAITING_PO_TOGGLE,
    RESET_AWAITING_PO_TOGGLE,
    AWAITING_PO_TOGGLE_MOBILE,
    RESET_AWAITING_PO_TOGGLE_MOBILE,
    SET_DENIED_OVERRIDE_CLICKED,
    DENIED_TOGGLE,
    GET_DENIED_ORDER,
    GET_DENIED_ORDER_SUCCESS,
    GET_DENIED_ORDER_FAILURE,
    FILTERS_UPDATE,
    DENIED_TOGGLE_TEMP,
    GET_DENIED_ORDER_FILTER,
    GET_DENIED_ORDER_FILTER_SUCCESS,
    GET_DENIED_ORDER_FILTER_FAILURE,
    DENIED_OVERRIDE_TOGGLE_CLICK,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const initialState = {
    loading: false,
    orderList: [],
    allOrderList: [],
    filters: [],
    filterData: [],
    statusCode: '',
    statusMessage: '',
    totalSearcResults: 0,
    totalDeniedOrder: 0,
    showOrderFilter: false,
    viewOrderListTab: true,
    appliedFilterIds: [],
    appliedViewsIds: [],
    quickFilterCounts: [],
    ordersFilterDates: {
        orderListStartDate: '',
        // convertDateToISOString(
        //     new Date(
        //         addDaysToDate(new Date(new Date().setHours(0, 0, 0, 0)))
        //     ),
        //     'start'
        // ),
        orderListEndDate: '',
        // convertDateToISOString(new Date(new Date()), 'end'),
    },
    dynamicZIndex: 0,
    nonTissuePoSum: 0,
    tissuePoSum: 0,
    totalPoSum: 0,
    toggleCheckedDsktop: false,
    ToggleChecked: false,
    isDeniedOverrideClicked: false,
    deniedOverrideToggle: false,
    deniedOverrideToggleTemp: false,
    deniedOrderFilters: [],
    deniedOverrideToggleClick:false,
    // isDeniedOverrideToggle:false,
};

const OrdersListReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ORDERS_LIST_DATA:
            return {
                ...state,
                loading: true,
            };
        case GET_ORDERS_LIST_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                quickFilterCounts: action.data.filters,
                ...action.data,
            };
        case GET_ORDERS_LIST_DATA_FAILURE:
            return {
                ...state,
                orderList: [],
                totalSearcResults: 0,
                loading: false,
            };
        case GET_ALL_ORDERS_LIST_DATA:
            return {
                ...state,
                loading: true,
            };
        case GET_ALL_ORDERS_LIST_DATA_SUCCESS:
            return {
                ...state,
                allOrderList: action.data.orderList,
                loading: false,
                quickFilterCounts: action.data.filters,
                ...action.data,
            };
        case GET_ALL_ORDERS_LIST_DATA_FAILURE:
            return {
                ...state,
                allOrderList: [],
                totalSearcResults: 0,
                loading: false,
            };
        case RESET_ORDER_LIST:
            return {
                ...state,
                orderList: [],
                totalSearcResults: 0,
                loading: false,
            };
        case GET_REFINED_ORDERS_LIST_DATA:
            return {
                ...state,
                ...action.data,
                loading: true,
            };
        case GET_REFINED_ORDERS_LIST_DATA_SUCCESS:
            return {
                ...state,
                ...action.data,
                orderList: action.data.orderList,
                nonTissuePoSum: action.data?.nonTissuePoSum
                    ? action.data.nonTissuePoSum
                    : 0,
                tissuePoSum: action.data?.tissuePoSum
                    ? action.data.tissuePoSum
                    : 0,
                totalPoSum: action.data?.totalPoSum
                    ? action.data.totalPoSum
                    : 0,
                loading: false,
                totalDeniedOrder:
                    action.data?.totalDeniedOrder >= 0
                        ? action.data?.totalDeniedOrder
                        : state.totalDeniedOrder,
                totalSearcResults: action.data?.totalSearcResults
                    ? action.data?.totalSearcResults
                    : 0
            };
        case GET_REFINED_ORDERS_LIST_DATA_FAILURE:
            return {
                ...state,
                ...action.data,
                orderList: [],
                totalSearcResults: 0,
                nonTissuePoSum: action.data?.nonTissuePoSum
                    ? action.data.nonTissuePoSum
                    : 0,
                tissuePoSum: action.data?.tissuePoSum
                    ? action.data.tissuePoSum
                    : 0,
                totalPoSum: action.data?.totalPoSum
                    ? action.data.totalPoSum
                    : 0,
                loading: false,
            };
        case GET_DENIED_ORDER:
            return {
                ...state,
                ...action.data,
                loading: true,
            };
        case GET_DENIED_ORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                totalDeniedOrder:
                    action.data?.totalDeniedOrder >= 0
                        ? action.data?.totalDeniedOrder
                        : state.totalDeniedOrder,
            };
        case GET_DENIED_ORDER_FAILURE:
            return {
                ...state,
                loading: false,
            };

        case SHOW_ORDER_FILTER:
            return { ...state, showOrderFilter: true };

        case CLOSE_ORDER_FILTER:
            return { ...state, showOrderFilter: false, viewOrderListTab: true };

        case TOGGLE_ORDER_FILTERS:
            return {
                ...state,
                viewOrderListTab: !state.viewOrderListTab,
            };
        case FILTER_AND_ORDERLIST_UPDATE:
            return {
                ...state,
                loading: true,
            };
        case ORDERS_LIST_FILTERS_UPDATE:
            return {
                ...state,
                filters: action.data.filters,
            };
        case ORDERS_LIST_DATA_UPDATE:
            return {
                ...state,
                orderList: action.data.orderList,
                totalSearcResults: action.data.totalSearcResults,
                nonTissuePoSum: action.data?.nonTissuePoSum
                    ? action.data.nonTissuePoSum
                    : 0,
                tissuePoSum: action.data?.tissuePoSum
                    ? action.data.tissuePoSum
                    : 0,
                totalPoSum: action.data?.totalPoSum
                    ? action.data.totalPoSum
                    : 0,
                //             nonTissuePoSum:0,
                // tissuePoSum: 0,
                // totalPoSum: 0,
                loading: false,
                totalDeniedOrder:
                    action.data?.totalDeniedOrder >= 0
                        ? action.data?.totalDeniedOrder
                        : state.totalDeniedOrder,
            };
        case GET_DENIED_ORDER_FILTER:
            return {
                ...state,
                ...action.data,
                loading: true,
            };
        case GET_DENIED_ORDER_FILTER_SUCCESS:
            return {
                ...state,
                deniedOrderFilters: action.data,
            };
        case GET_DENIED_ORDER_FILTER_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case FILTERS_UPDATE:
            return {
                ...state,
                filterData: action.data.filters,
                // isDeniedOverrideToggle:action.data.isDeniedOverrideToggle,
            };
        // case DENIED_TOGGLE_FILTER:
        //     return {
        //         ...state,
        //         isDeniedOverrideToggle:action.data,
        //     };
        case DENIED_TOGGLE_TEMP:
            return {
                ...state,
                deniedOverrideToggleTemp: action.payload,
            };
        case SET_ORDERS_DATE_FILTER:
            return {
                ...state,
                ordersFilterDates: {
                    ...state.ordersFilterDates,
                    ...action.data,
                },
            };
        case SET_DYNAMIC_Z_INDEX:
            return {
                ...state,
                dynamicZIndex: action.payload,
            };
        case SET_ORDERS_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case AWAITING_PO_TOGGLE:
            return {
                ...state,
                toggleCheckedDsktop: action.payload,
            };
        case DENIED_TOGGLE:
            return {
                ...state,
                deniedOverrideToggle: action.payload,
            };
        case RESET_AWAITING_PO_TOGGLE:
            return {
                ...state,
                ...initialState,
            };
        case AWAITING_PO_TOGGLE_MOBILE:
            return {
                ...state,
                ToggleChecked: action.payload,
            };
        case RESET_AWAITING_PO_TOGGLE_MOBILE:
            return {
                ...state,
                ...initialState,
            };
        case SET_DENIED_OVERRIDE_CLICKED:
            return {
                ...state,
                isDeniedOverrideClicked: action.payload,
            };
        case DENIED_OVERRIDE_TOGGLE_CLICK:
            return {
                ...state,
                deniedOverrideToggleClick: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default persistReducer(
    {
        key: 'ordersListReducerKey',
        storage: storage,
        whitelist: [
            'toggleCheckedDsktop',
            'ToggleChecked',
            'orderList',
            'totalSearcResults',
            'filters',
            'isDeniedOverrideClicked',
            'totalDeniedOrder',
            'deniedOverrideToggle',
            'deniedOverrideToggleTemp',
            'deniedOverrideToggleClick',
            'deniedOrderFilters',
        ],
    },
    OrdersListReducer
);
